import App from "./App";
import myData from './AppConfig.json';


const HotelFront = () => {
  return <App data={myData as any}/>;
};

export default HotelFront;